export default __webpack_public_path__ + "static/media/43.c4a6970c.jpg";